import * as $ from "jquery";

export class UrlHelper {
    public static getRootRouteUrl(): string {
        const rootUrl = this.getRootRouteDataAttributeValue();
        return this.addTrailingSlash(rootUrl);
    }

    public static getRootRouteUrlWithoutSlash(): string {
        const rootUrl = this.getRootRouteDataAttributeValue();
        return this.removeTrailingSlash(rootUrl);
    }

    private static getRootRouteDataAttributeValue(): string {
        const $javascriptSettings = $("[data-javascript-settings]");
        const rootUrl: string = $javascriptSettings.data("javascript-root-url") as any;
        return rootUrl;
    }

    private static addTrailingSlash(input: string): string {
        const inputLength = input.length;
        if (inputLength > 1 && input.charAt(inputLength - 1) !== "/") {
            return input + "/";
        }

        return input;
    }

    private static removeTrailingSlash(input: string): string {
        const inputLength = input.length;
        if (inputLength > 1 && input.charAt(inputLength - 1) === "/") {
            return input.slice(0, inputLength - 1);
        }

        return input;
    }
}
